import type { ObjectWithDistanceProperty } from '@/lib/models/location';
import type { Point } from '@/lib/util';

export function translateZorgbaseResult(item: ZorgbaseResult, locale: string): TranslatedZorgbaseResult {
	const translated = { ...item };

	switch (locale) {
		case 'en':
			translated.acceptsPatientsRestrictions = item.acceptsPatientsRestrictionsEnglish;
			translated.acceptsPassersByRestrictions = item.acceptsPassersByRestrictionsEnglish;
			return translated;
		default:
			return translated;
	}
}

export interface TranslatedZorgbaseResult extends ObjectWithDistanceProperty, Point {
	id: number;

	// last_updated: string;
	lastUpdated: string;

	visible: number;
	agbCode?: string;

	label: string;

	addressString: string;

	workPhonenumber: string;
	url?: string;

	acceptsPatients?: number;
	acceptsPatientsUrl?: string;
	acceptsPatientsRestrictions?: string;

	acceptsPassersBy?: number;
	acceptsPassersByRestrictions?: string;

	isManaged?: number;

	mainContactId?: number;
}

export default interface ZorgbaseResult extends TranslatedZorgbaseResult {
	acceptsPatientsRestrictionsEnglish?: string;
	acceptsPassersByRestrictionsEnglish?: string;
}
